import React from 'react';

import RoleList from 'Core/Components/RoleList';
import ContentController from 'RLX/Controllers/ContentController';

class RoleListEditor extends ContentController {
  constructor (props) {
    super(props);
  }

  static getInitialShape () {
    return {
      props: { roles: [], groupBy: null, filterBy: null  }
    };
  }

  getBlockName () {
    return 'Role List';
  }

  getClassName () {
    return 'RoleList';
  }

  getPreview () {
    return <RoleList {...this.props.content.props} />
  }

  shouldDisplayPreviewInline () {
    return false;
  }

  getFields () {
    const { content } = this.props;
    const { roles, groupBy, filterBy } = content.props;
    return [
      {
        type: 'select',
        icon: 'filter',
        className: 'half',
        label: 'Filterable By',
        options: [
          { value: null, text: 'None' },
          { value: 'season', text: 'Season' },
          { value: 'category', text: 'Category' },
          { value: 'company', text: 'Company' }
        ],
        value: filterBy,
        onChange: this.applyUpdate((filterBy, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, filterBy } };
        })
      },
      {
        type: 'select',
        className: 'half',
        icon: 'object-group',
        label: 'Grouped By',
        options: [
          { value: null, text: 'None' },
          { value: 'season', text: 'Season' },
          { value: 'category', text: 'Category' },
          { value: 'company', text: 'Company' }
        ],
        value: groupBy,
        onChange: this.applyUpdate((groupBy, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, groupBy } };
        })
      },
      {
        type: 'roleset',
        icon: 'vcard',
        label: 'Roles',
        value: roles,
        onChange: this.applyUpdate((roles, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, roles } };
        })
      }
    ];
  };
};

export default RoleListEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/RoleListEditor.jsx